/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_4_CInputs */

const en_mk_how_4_c = /** @type {(inputs: Mk_How_4_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hand over to clients with Studio, according to your plan`)
};

const id_mk_how_4_c = /** @type {(inputs: Mk_How_4_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serahkan ke klien melalui Studio sesuai paket`)
};

/**
* | output |
* | --- |
* | "Hand over to clients with Studio, according to your plan" |
*
* @param {Mk_How_4_CInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_4_c = /** @type {((inputs?: Mk_How_4_CInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_4_CInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_4_c(inputs)
	return en_mk_how_4_c(inputs)
});